/*
 * Copyright (c) 2023-2024. Haodong JU
 */
import Vue from 'vue'
import App from './App.vue'
import router from './model/global/router'
import store from './model/global/store'
import './plugins/apexchart'

import i18n from './i18n'
import Print from 'vue-print-nb'
import { isAppInitialized, loadConfig, requireOfflineMode } from './model/global/GlobalSettings'
import dayjs from 'dayjs'
import weekday from 'dayjs/plugin/weekday'
import relativeTime from 'dayjs/plugin/relativeTime'
import { getCurrentUserId } from '@/model/dataLayer/api/SaaS/user'
import vuetify from './plugins/vuetify'
import 'shepherd.js/dist/css/shepherd.css'
import '../public/fonts.css'

Vue.use(Print)
const duration = require('dayjs/plugin/duration')
const isoWeek = require('dayjs/plugin/isoWeek')
const utc = require('dayjs/plugin/utc')
dayjs.extend(isoWeek)
dayjs.extend(duration)
dayjs.extend(relativeTime)
dayjs.extend(weekday)
dayjs.extend(utc)

export function uuidv4 () {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g,
    c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16))
}

export let lastRoute = ''

export function resetLastRoute () {
  lastRoute = ''
}

router.beforeEach((to, from, next) => {
  const passThrough = ['LoginPage', 'cancel', 'success'].includes(to.name)

  // LoadingPage 只是初始化期间的过渡页，不能覆盖真正的目标路由
  if (!passThrough && to.name && to.name !== 'LoadingPage') {
    lastRoute = to.name
  }

  // 初始化（恢复登录状态、进入门店）还没完成时，先显示登录页的 loading，避免白屏。
  // 初始化完成后由 login()/determinedActivationStep 负责跳转到目标页面。
  if (!isAppInitialized() && !passThrough) {
    next({ name: 'LoginPage' })
    return
  }

  if (passThrough) {
    next()
    return
  }

  if (!getCurrentUserId() && !requireOfflineMode()) {
    next({ name: 'LoginPage' })
    return
  }
  next()
})

function getRouteNameFromLocation () {
  try {
    const hash = window.location.hash ? window.location.hash.slice(1) : '/'
    return router.match(hash || '/').name || ''
  } catch (e) {
    return ''
  }
}

async function initial () {
  // 在初始化开始前先记录刷新前的路由。
  // 如果 Firebase/Firestore 恢复得很快，gotoLastRoute() 可能在路由守卫执行之前就被调用，
  // 这时 lastRoute 还是空的，会默认跳到 dashboard，导致刷新后永远丢失原路由。
  lastRoute = getRouteNameFromLocation()

  await loadConfig()

  new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App)
  }).$mount('#app')
}

initial()
